import { useEffect } from 'react'
import useModal from '../../hooks/useModal';
import Header from '../../components/Layout/Header';
import { ToastContainer } from 'react-toastify/unstyled';
import NavBarAdmin from '../../components/Admin/Layout/NavBarAdmin';
import CreateRelaunch from '../../components/Admin/Modales/CreateRelaunch';
import RelaunchAdminTable from '../../components/Admin/Table/RelaunchAdminTable';
import Footer from '../../components/Layout/Footer';
import { useRelaunchStore } from '../../stores/admin/relauch';
import repeat from '../../assets/icons/repeat.svg';
import { useParams } from 'react-router-dom';
import { getRelaunchs } from '../../services/Api/partnerService';
import { showToastError } from '../../services/Toasts/toasts';
import { useServiceStore } from '../../stores/admin/service';

const AdminRelaunch = () => {
  // Hook
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();
  const { relaunchs, setRelaunchs } = useRelaunchStore();
  const { idPartner } = useParams();
  const { update } = useServiceStore();

  useEffect(() => {
    getRelaunchs(Number(idPartner))
    .then((res) => {
      setRelaunchs(res.data);
    })
    .catch((err) => {
      showToastError("Une erreur est survenue.");
    }); 
  }, [update, idPartner]);

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      {isModalOpen ? modalContent : null}
      <Header />
      <div className="w-full flex justify-start items-start">
        <ToastContainer position="top-center" />
        <NavBarAdmin />
        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          {/* Header Section avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 my-3 border border-gray-100">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-yellow-trio rounded-xl">
                  <img src={repeat} alt="repeat" className="w-6 h-6 text-grey-trio" />
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-700 font-K2D">
                    Liste des relances <span className="text-yellow-trio">({relaunchs.length})</span>
                  </h1>
                  <p className="text-gray-600 text-md mt-1">
                    Gérez les relances
                  </p>
                </div>
              </div>
              
              <button
                className="px-6 py-3 bg-yellow-trio text-gray-700 cursor-pointer font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-2"
                onClick={() => openModal(<CreateRelaunch closeModal={closeModal} />)}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Créer une relance
              </button>
            </div>
          </div>

          {/* Table des collaborateurs  */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
            <RelaunchAdminTable />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default AdminRelaunch
